import React from 'react'
import { Texto } from '@gravitate-js/excalibrr'
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons'

interface DeltaDisplayProps {
  value: number
  invertColors?: boolean
  noDataMessage?: string
}

export function DeltaDisplay({ value, invertColors = false, noDataMessage }: DeltaDisplayProps) {
  const isPositive = value > 0
  const isNegative = value < 0

  // Determine icon color based on value and inversion
  let iconColor = '#666' // neutral gray for zero
  if (isPositive) {
    iconColor = invertColors ? '#DC3545' : '#28A745' // red if inverted, green if not
  } else if (isNegative) {
    iconColor = invertColors ? '#28A745' : '#DC3545' // green if inverted, red if not
  }

  if (value === 0) {
    if (noDataMessage) {
      return (
        <Texto category='p2' style={{ color: '#999', fontSize: '11px', fontStyle: 'italic' }}>
          {noDataMessage}
        </Texto>
      )
    }
    return null
  }

  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {isPositive ? (
        <CaretUpOutlined style={{ fontSize: '12px', color: iconColor }} />
      ) : (
        <CaretDownOutlined style={{ fontSize: '12px', color: iconColor }} />
      )}
      <Texto category='p2' style={{ color: '#666' }}>
        {Math.abs(value).toFixed(0)}%
      </Texto>
    </span>
  )
}
